module.exports = __webpack_public_path__ + "img/wximg20.1b3f2709.png";